import React, { useState } from 'react'
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import Autocomplete from '@mui/material/Autocomplete';
import { privateBookingApi, InsuranceCardScanResult } from '../../Service/Cousult.service';
import InsuranceCardScanner from '../../Common/InsuranceCardScanner/InsuranceCardScanner';
import { useNavigate } from 'react-router-dom';
import { emailRegex } from '../../Utils/Regex';
import { CircularProgress } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import CongratsModel2 from '../../Common/CongratsPopup2/CongratsPopup2';
import { GIFTCARD } from '../../Routes/RouteConstent';
import isMebershipAndActiveCheck from '../../Utils/membership_check';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import napsLogo from '../../Assets/img/naps-logo.png';
import bobbieLogo from '../../Assets/img/bobbie-logo.png';
import './BobbieFeedingSupport.scss';

function BobbieFeedingSupport() {

    const [error, setError] = React.useState<any>({})
    const [congrats, setCongrats] = useState(false)
    const [loading, setLoading] = useState(false)
    const [noInsurance, setNoInsurance] = useState(false)

    const Navigate = useNavigate()
    const dispatch = useDispatch()

    let user: any = localStorage.getItem("Nurture_user_data")
    user = JSON.parse(user)

    let iValue: any = {
        first_name: user?.first_name,
        last_name: user?.last_name,
        email: user?.email,
        phone: user?.phone,
        // Auto-fill mom's own DOB (first DOB field) from the logged-in account.
        // The insured-person DOB (policy_holder_dob) is left blank on purpose and
        // is only filled manually or from a scanned card.
        mom_dob: user?.dob && dayjs(user.dob).isValid() ? dayjs(user.dob) : '',
        insured_relationship: 'Self',
        insured_first_name: '',
        insured_last_name: '',
    }
    const [values, setValues] = React.useState<any>(iValue)

    const consult_type = [
        { label: 'Initial Postpartum Consultation', value: 1 },
        { label: 'Follow-up Consultation', value: 2 },
        { label: 'Bottle Consultation', value: 3 },
        { label: 'Prenatal Consultation', value: 4 },
        { label: 'Virtual Consultation', value: 5 },

    ]
    const handlerRadioBtn = (e: any) => {

        if (e.target.name === "would_you_like_to_book_an_in_home_or_virtual_consult") {
            setValues({
                ...values,
                [e.target.name]: e.target.value
            })

        }
        if (e.target.name === "prenatal_classes_being_requested") {
            setValues({
                ...values,
                [e.target.name]: e.target.value
            })
        }
        if (e.target.name === "are_you_a_current_member_of_nurture_by_naps") {
            setValues({
                ...values,
                [e.target.name]: e.target.value
            })
            setError({
                ...error,
                [e.target.name]: ""
            })
        }
    }
    const handleChangeInfo = (e: any) => {
        let name = e.target.name;
        let value = e.target.value;

        if (["first_name", "last_name", 'mom_dob'].includes(name)) {
            setError({
                ...error,
                [name]: value ? "" : "Field is required"
            });
        }

        if (name === "email") {
            if (!emailRegex.test(value)) {
                setError({
                    ...error,
                    [name]: "Email in not valid"
                })
            } else {
                setError({
                    ...error,
                    [name]: ""
                })
            }
        }
        if (name === "phone") {
            if (value.length < 10 || value.length > 10) {
                setError({
                    ...error,
                    [name]: "Contact number should be of 10 digits"
                })
            } else {
                setError({
                    ...error,
                    [name]: ""
                })
            }
        }
        setValues({ ...values, [name]: value });
        // if name in array then set error to empty
        const resetErrorFields = [
            "total_anticipated_participants",
            "street_address",
            "city",
            "state",
            "zip_code",
            "reason_for_visit",
            "insurance_carrier",
            "insured_first_name",
            "insured_last_name"
        ];

        if (resetErrorFields.includes(name)) {
            setError({
                ...error,
                [name]: ""
            });
        }

        setValues({
            ...values,
            [e.target.name]: e.target.value
        })

    }
    const dateHandler = (val: any, name: string) => {
        setValues({
            ...values,
            [name]: val
        })
        setError({
            ...error,
            [name]: ""
        })
    }
    const handleSelectConsult = (e: any, val: any) => {
        setValues({
            ...values,
            ["type_of_consultation"]: val?.label
        })
        setError({
            ...error,
            ["type_of_consultation"]: ""
        })
    }

    const handleInsuredRelationshipChange = (e: any) => {
        const next = e.target.value as 'Self' | 'Spouse'
        // Only manage relationship + spouse name fields here. DOB is always
        // entered manually (no auto-fill / no auto-clear).
        setValues((prev: any) => ({
            ...prev,
            insured_relationship: next,
            insured_first_name: '',
            insured_last_name: '',
        }))
        setError((prev: any) => ({
            ...prev,
            insured_first_name: '',
            insured_last_name: '',
        }))
    }

    const handleLactationSubmit = async (e: any) => {

        e.preventDefault()
        try {
            const spouseFieldsMissing = !noInsurance
                && values?.insured_relationship === 'Spouse'
                && (!values?.insured_first_name || !values?.insured_last_name)

            if (
                !values?.type_of_consultation ||
                !values?.street_address || !values?.city || !values?.state || !values?.zip_code || !values?.due_date || !values?.reason_for_visit || (!values?.insurance_carrier && !noInsurance)
                || !values?.are_you_a_current_member_of_nurture_by_naps || !values?.mom_dob
                || spouseFieldsMissing) {

                let errors: any = {}
                if (!values?.first_name) {
                    errors.first_name = "First name is Required"
                }
                if (!values?.mom_dob) {
                    errors.first_name = "Please select date"
                }
                if (!values?.insurance_carrier && !noInsurance) {
                    errors.insurance_carrier = "Please Enter the Value"
                }
                if (!values?.reason_for_visit) {
                    errors.reason_for_visit = "Please Enter the Value"
                }
                if (!values?.due_date) {
                    errors.due_date = "Please select date"
                }

                if (!values?.last_name) {
                    errors.last_name = "Last name is Required"
                }

                if (!values?.email) {
                    errors.email = "Email is required"
                }

                if (!values?.phone) {
                    errors.phone = "Phone no. is Required"
                }

                if (values?.phone.length < 10 || values?.phone.length > 10) {
                    errors.phone = "Contact number should be of 10 digits"
                }
                if (!values?.type_of_consultation) {
                    errors.type_of_consultation = "Please Select the Value"
                }
                if (!values?.street_address) {
                    errors.street_address = "Please Enter the Value"
                }
                if (!values?.city) {
                    errors.city = "Please Enter the Value"
                }

                if (!values?.zip_code) {
                    errors.zip_code = "Please Enter the Value"
                }
                if (!values?.state) {
                    errors.state = "Please Enter the Value"
                }
                if (!values?.are_you_a_current_member_of_nurture_by_naps) {
                    errors.are_you_a_current_member_of_nurture_by_naps = "Please Select the Value"
                }
                if (!noInsurance && values?.insured_relationship === 'Spouse') {
                    if (!values?.insured_first_name) {
                        errors.insured_first_name = "Spouse first name is required"
                    }
                    if (!values?.insured_last_name) {
                        errors.insured_last_name = "Spouse last name is required"
                    }
                }
                setError(errors)

            } else {
                setLoading(true)
                let param = {
                    type: "Bobbie Feeding Support Consult Request Form",
                    user_id: user?.id,
                    first_name: values?.first_name,
                    last_name: values?.last_name,
                    email: values?.email,
                    phone: values?.phone,
                    mom_dob: values?.mom_dob,
                    type_of_consultation: values?.type_of_consultation,
                    street_address: values?.street_address,
                    city: values?.city,
                    state: values?.state,
                    zip_code: values?.zip_code,
                    due_date: values?.due_date?.$d,
                    reason_for_visit: values?.reason_for_visit,
                    insurance_carrier: noInsurance ? "NONAVAILABLE" : values?.insurance_carrier,
                    policy_number: noInsurance ? "" : values?.policy_number,
                    group_number: noInsurance ? "" : values?.group_number,
                    policy_holder_dob: noInsurance ? "" : values?.policy_holder_dob,
                    insured_relationship: noInsurance ? "Self" : (values?.insured_relationship || "Self"),
                    insured_first_name: noInsurance ? "" : (values?.insured_first_name || ""),
                    insured_last_name: noInsurance ? "" : (values?.insured_last_name || ""),
                    insurance_card_front: noInsurance ? "" : (values?.insurance_card_front || ""),
                    insurance_card_back: noInsurance ? "" : (values?.insurance_card_back || ""),
                    are_you_a_current_member_of_nurture_by_naps: values?.are_you_a_current_member_of_nurture_by_naps,
                }

                let res: any = await privateBookingApi(param)
                isMebershipAndActiveCheck(res, Navigate, toast, dispatch)
                if (res?.data?.success) {
                    setValues({
                        first_name: user?.first_name,
                        last_name: user?.last_name,
                        email: user?.email,
                        phone: user?.phone,
                        type_of_consultation: "",
                        street_address: "",
                        city: "",
                        state: "",
                        zip_code: "",
                        due_date: "",
                        reason_for_visit: "",
                        insurance_carrier: "",
                        policy_number: "",
                        group_number: "",
                        policy_holder_dob: "",
                        insured_relationship: "Self",
                        insured_first_name: "",
                        insured_last_name: "",
                        insurance_card_front: "",
                        insurance_card_back: "",
                        mom_dob: user?.dob && dayjs(user.dob).isValid() ? dayjs(user.dob) : "",
                        are_you_a_current_member_of_nurture_by_naps: "",
                    })
                    setNoInsurance(false)
                    setCongrats(true)
                    setLoading(false)
                } else {
                    setLoading(false)
                }


            }
        } catch (err) {
            console.log(err)
            setLoading(false)
        }
    }

    return (
        <div>
            <CongratsModel2
                open={congrats}
                setOpen={setCongrats}
                title="Thank you for your request!"
                btnText="Send gift card to your friend"
                Page={GIFTCARD}
                text={'We have received your form submission and someone from our team will be in touch ASAP. In the meantime, feel free to check out our other offerings. Or if you have a friend you think would be interested in the same booking as you, tell them using the button below!'} />

            <section className='private-consult step-container'>
                <div className='consult-section-heading text-center'>
                    <div className='bobbie-feeding-logos d-flex justify-content-center align-items-center mb-4'>
                        <img src={bobbieLogo} alt='bobbie' className='bobbie-feeding-logo' />
                        <span className='bobbie-feeding-logo-divider' aria-hidden='true'>×</span>
                        <img src={napsLogo} alt='naps' className='bobbie-feeding-logo' />
                    </div>
                    <h3 className='mb-3 mt-2'>Request a Feeding Consultation</h3>
                    <p className="text-center">
                        As a Bobbie Stay Stocked&trade; Member, your one-on-one feeding and lactation consult with us is fully covered.
                        If your insurance covers it, we handle the out-of-pocket cost. If it doesn't, we will.
                        Fill out this request form, and our team will follow up with next steps to check your coverage and schedule your consult as soon as possible.
                    </p>
                </div>
                <form className=' '>
                    <div className='row mb-3'>
                        <div className="form-group col-lg-6 col-md-6 mb-3">
                            <label>Mom's First Name <span className='mandatory text-danger mx-2'>*</span></label>
                            <input type="text" name='first_name' value={values.first_name} className='form-control' onChange={handleChangeInfo} placeholder='Enter first name' />
                            <h4 className="error">{error.first_name}</h4>

                        </div>
                        <div className="form-group col-lg-6 col-md-6 mb-3">
                            <label>Mom's Last Name<span className='mandatory text-danger mx-2'>*</span></label>
                            <input type="text" name='last_name' value={values?.last_name} className='form-control' onChange={handleChangeInfo} placeholder='Enter last name' />
                            <h4 className="error">{error.last_name}</h4>

                        </div>
                    </div>
                    <div className='row mb-3'>
                        <div className="form-group col-lg-6 col-md-6 mb-3">
                            <label>Email <span className='mandatory text-danger mx-2'>*</span></label>
                            <input type="text" name='email' value={values?.email} className='form-control' onChange={handleChangeInfo} placeholder='Enter email address' />
                            <h4 className="error">{error?.email}</h4>
                        </div>
                        <div className="form-group col-lg-6 col-md-6 mb-3">
                            <label>Phone Number <span className='mandatory text-danger mx-2'>*</span></label>
                            <input type="text" name='phone' value={values?.phone} className='form-control' onChange={handleChangeInfo} placeholder='Enter phone number' />
                            <h4 className="error">{error?.phone}</h4>
                        </div>
                    </div>
                    <div className='row mb-3'>
                        <div className="form-group col-lg-12 col-md-12 mb-3">
                            <label>Mom's DOB<span className='mandatory text-danger mx-2'>*</span></label>
                            <LocalizationProvider dateAdapter={AdapterDayjs} >

                                <Stack spacing={3}>
                                    <MobileDatePicker
                                        value={values?.mom_dob || ""}
                                        onChange={(val: any) => dateHandler(val, "mom_dob")}
                                        renderInput={(params: any) => <TextField {...params} placeholder="MM-DD-YYYY" className='due-date-field' />}
                                    />
                                </Stack>
                            </LocalizationProvider>
                            <h4 className="error">{error.mom_dob}</h4>
                        </div>
                    </div>
                    <div className='row mb-3'>
                        <div className="form-group col-lg-12 col-md-12 mb-3">
                            <label >Type of Consultation: <span className='mandatory text-danger mx-2'>*</span> </label>
                            <Autocomplete
                                disablePortal
                                disableClearable
                                id="consult-type"
                                options={consult_type}
                                value={values?.type_of_consultation || ""}
                                className={'mu-custom-fields'}
                                onChange={handleSelectConsult}
                                renderInput={(params) => <TextField {...params} name='type_of_consultation' placeholder='Select Consultation' />}
                            />

                            <h4 className="error">{error.type_of_consultation}</h4>
                        </div>
                    </div>
                    <div className='row mb-3'>
                        <div className="form-group col-lg-12 col-md-12 mb-3">
                            <label>Street address <span className='mandatory text-danger mx-2'>*</span></label>
                            <input type="text" name='street_address' value={values?.street_address} className='form-control' onChange={handleChangeInfo} />
                            <h4 className="error">{error.street_address}</h4>
                        </div>
                    </div>
                    <div className='row mb-3'>
                        <div className="form-group col-lg-4 col-md-4 mb-3">
                            <label>City <span className='mandatory text-danger mx-2'>*</span></label>
                            <input type="text" name='city' className='form-control' value={values?.city} placeholder='' onChange={handleChangeInfo} />
                            <h4 className="error">{error.city}</h4>
                        </div>
                        <div className="form-group col-lg-4 col-md-4 mb-3">
                            <label>State <span className='mandatory text-danger mx-2'>*</span></label>
                            <input type="text" name='state' className='form-control' placeholder='' value={values?.state} onChange={handleChangeInfo} />
                            <h4 className="error">{error.state}</h4>
                        </div>
                        <div className="form-group col-lg-4 col-md-4 mb-3">
                            <label>Zip Code <span className='mandatory text-danger mx-2'>*</span></label>
                            <input type="text" name='zip_code' className='form-control' placeholder='' value={values?.zip_code} onChange={handleChangeInfo} />
                            <h4 className="error">{error.zip_code}</h4>
                        </div>
                    </div>

                    <div className='row mb-3'>
                        <div className="form-group col-lg-12 col-md-12 mb-3 due_dt_container">
                            <label >Due Date/Child's Birthday <span className='mandatory text-danger mx-2'>*</span> </label>
                            <LocalizationProvider dateAdapter={AdapterDayjs} >

                                <Stack spacing={3}>
                                    <MobileDatePicker
                                        value={values?.due_date || ""}
                                        onChange={(val: any) => dateHandler(val, "due_date")}
                                        renderInput={(params: any) => <TextField {...params} placeholder="MM-DD-YYYY" className='due-date-field' />}
                                    />
                                </Stack>
                            </LocalizationProvider>
                            <h4 className="error">{error.due_date}</h4>
                        </div>
                    </div>

                    <div className='row mb-3'>
                        <div className="form-group col-lg-12 col-md-12 mb-3">
                            <label>Reason for visit<span className='mandatory text-danger mx-2'>*</span></label>
                            <input type="text" name='reason_for_visit' value={values?.reason_for_visit} className='form-control'
                                placeholder='' onChange={handleChangeInfo} />
                            <h4 className="error">{error.reason_for_visit}</h4>
                        </div>
                    </div>

                    <div className='row mb-3'>
                        <div className="form-group col-lg-12 col-md-12 mb-3">
                            <InsuranceCardScanner
                                disabled={noInsurance}
                                onImageCaptured={(side, dataUrl) => {
                                    setValues((prev: any) => ({
                                        ...prev,
                                        [side === 'front' ? 'insurance_card_front' : 'insurance_card_back']: dataUrl || '',
                                    }))
                                }}
                                onScanned={(fields: InsuranceCardScanResult) => {
                                    setNoInsurance(false)
                                    setValues((prev: any) => ({
                                        ...prev,
                                        insurance_carrier: fields.insurance_carrier ?? prev?.insurance_carrier ?? '',
                                        policy_number: fields.policy_number ?? prev?.policy_number ?? '',
                                        group_number: fields.group_number ?? prev?.group_number ?? '',
                                        policy_holder_dob: fields.policy_holder_dob ?? prev?.policy_holder_dob ?? '',
                                    }))
                                    setError((prev: any) => ({
                                        ...prev,
                                        insurance_carrier: fields.insurance_carrier ? '' : prev?.insurance_carrier,
                                    }))
                                }}
                            />
                        </div>
                    </div>

                    <div className='row mb-3'>
                        <div className="form-group col-lg-12 col-md-12 mb-3">
                            <div className="form-check mb-2">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="noInsuranceCheckbox"
                                    checked={noInsurance}
                                    onChange={(e) => {
                                        setNoInsurance(e.target.checked)
                                        if (e.target.checked) {
                                            setValues({
                                                ...values,
                                                insurance_carrier: '',
                                                policy_number: '',
                                                group_number: '',
                                                policy_holder_dob: '',
                                                insured_relationship: 'Self',
                                                insured_first_name: '',
                                                insured_last_name: '',
                                                insurance_card_front: '',
                                                insurance_card_back: '',
                                            })
                                            setError({
                                                ...error,
                                                insurance_carrier: '',
                                                insured_first_name: '',
                                                insured_last_name: '',
                                            })
                                        }
                                    }}
                                />
                                <label className="form-check-label" htmlFor="noInsuranceCheckbox">
                                    I do not have insurance
                                </label>
                            </div>
                            <label>Mom's Insurance Carrier{!noInsurance && <span className='mandatory text-danger mx-2'>*</span>}</label>
                            <input type="text" name='insurance_carrier' value={noInsurance ? '' : (values?.insurance_carrier || '')} className='form-control'
                                placeholder='' onChange={handleChangeInfo} disabled={noInsurance} />
                            <h4 className="error">{error.insurance_carrier}</h4>
                        </div>
                    </div>
                    <div className='row mb-3'>
                        <div className="form-group col-lg-12 col-md-12 mb-3">
                            <label>Policy #</label>
                            <input type="text" name='policy_number' value={noInsurance ? '' : (values?.policy_number || '')} className='form-control'
                                placeholder='' onChange={handleChangeInfo} disabled={noInsurance} />
                            <h4 className="error">{error.policy_number}</h4>
                        </div>
                    </div>
                    <div className='row mb-3'>
                        <div className="form-group col-lg-12 col-md-12 mb-3">
                            <label>Group #</label>
                            <input type="text" name='group_number' value={noInsurance ? '' : (values?.group_number || '')} className='form-control'
                                placeholder='' onChange={handleChangeInfo} disabled={noInsurance} />
                            <h4 className="error">{error.group_number}</h4>
                        </div>
                    </div>
                    <div className='row mb-3'>
                        <div className="form-group col-lg-12 col-md-12 mb-3">
                            <label>Insured Person {!noInsurance && <span className='mandatory text-danger mx-2'>*</span>}</label>
                            <select
                                name='insured_relationship'
                                className='form-control'
                                value={values?.insured_relationship || 'Self'}
                                onChange={handleInsuredRelationshipChange}
                                disabled={noInsurance}
                            >
                                <option value='Self'>Self</option>
                                <option value='Spouse'>Spouse</option>
                            </select>
                        </div>
                    </div>
                    {!noInsurance && values?.insured_relationship === 'Spouse' && (
                        <div className='row mb-3'>
                            <div className="form-group col-lg-6 col-md-6 mb-3">
                                <label>Spouse First Name <span className='mandatory text-danger mx-2'>*</span></label>
                                <input type="text" name='insured_first_name' value={values?.insured_first_name || ''} className='form-control'
                                    placeholder='' onChange={handleChangeInfo} />
                                <h4 className="error">{error.insured_first_name}</h4>
                            </div>
                            <div className="form-group col-lg-6 col-md-6 mb-3">
                                <label>Spouse Last Name <span className='mandatory text-danger mx-2'>*</span></label>
                                <input type="text" name='insured_last_name' value={values?.insured_last_name || ''} className='form-control'
                                    placeholder='' onChange={handleChangeInfo} />
                                <h4 className="error">{error.insured_last_name}</h4>
                            </div>
                        </div>
                    )}
                    <div className='row mb-3'>
                        <div className="form-group col-lg-12 col-md-12 mb-3">
                            <label>Policy Holder DOB #</label>
                            <input type="text" name='policy_holder_dob' value={noInsurance ? '' : (values?.policy_holder_dob || '')} className='form-control'
                                placeholder='' onChange={handleChangeInfo} disabled={noInsurance} />
                            <h4 className="error">{error.policy_holder_dob}</h4>
                        </div>
                    </div>

                    <div className="radio-area mb-3">
                        <h4>Are you a current member of Nurture by NAPS? <span className='mandatory text-danger mx-2'>* </span></h4>
                        {(!!user?.is_stripe_membership || !user) && <div className="custom-control custom-radio">
                            <div className="form-check">
                                <input className="form-check-input" type="radio" name="are_you_a_current_member_of_nurture_by_naps"
                                    checked={values?.are_you_a_current_member_of_nurture_by_naps === "Yes, give me my member discount!"} value="Yes, give me my member discount!" onChange={handlerRadioBtn} id="discountYes" />
                                <label className="form-check-label" htmlFor='discountYes'>
                                    Yes, give me my member discount!
                                </label>
                            </div>
                        </div>}

                        <div className="custom-control custom-radio">
                            <div className="form-check">
                                <input className="form-check-input" type="radio"
                                    checked={values?.are_you_a_current_member_of_nurture_by_naps === "No, but I would like more information"}
                                    name="are_you_a_current_member_of_nurture_by_naps" value="No, but I would like more information" onChange={handlerRadioBtn} id="discountNo" />
                                <label className="form-check-label" htmlFor='discountNo' >
                                    No, but I would like more information
                                </label>
                            </div>
                        </div>
                        <p className="error">{error.are_you_a_current_member_of_nurture_by_naps}</p>
                    </div>



                    <div className='section-navigation my-5 d-flex justify-content-between'>
                        <button className='primary-blue-small-btn next w-100' disabled={loading} onClick={handleLactationSubmit}>{loading ? <CircularProgress /> : 'Submit'}</button>
                    </div>
                </form>
            </section>
        </div>
    )
}

export default BobbieFeedingSupport
